import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-easy-crop";

import useFileUpload from "../../../../../../hooks/dataSenders/singleUpload";

const TokenomicsChartModal = ({
  show,
  handleClose,
  projectSetup,
  setProjectSetup,
  setLoader,
}) => {
  const darkChartInputRef = useRef(null);
  const lightChartInputRef = useRef(null);
  const { uploadFile } = useFileUpload();

  // Local state for temporary changes
  const [localDarkChart, setLocalDarkChart] = useState(null);
  const [localLightChart, setLocalLightChart] = useState(null);

  const [uploadingDark, setUploadingDark] = useState(false);
  const [uploadingLight, setUploadingLight] = useState(false);
// Crop States
const [cropModalOpen, setCropModalOpen] = useState(false);
const [imageSrc, setImageSrc] = useState(null);
const [crop, setCrop] = useState({ x: 0, y: 0 });
const [zoom, setZoom] = useState(1);
const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
const [currentType, setCurrentType] = useState(null); // "dark" or "light"
const onCropComplete = (croppedArea, croppedPixels) => {
  setCroppedAreaPixels(croppedPixels);
};
const getCroppedImg = async () => {
  const image = new Image();
  image.src = imageSrc;

  await new Promise((resolve) => {
    image.onload = resolve;
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    croppedAreaPixels.width,
    croppedAreaPixels.height
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    }, "image/jpeg");
  });
};

  // Initialize local state with current values when modal opens
  useEffect(() => {
    if (show) {
      setLocalDarkChart(projectSetup.tokenomicsChartDark.value);
      setLocalLightChart(projectSetup.tokenomicsChartLight.value);
    }
  }, [
    show,
    projectSetup.tokenomicsChartDark.value,
    projectSetup.tokenomicsChartLight.value,
  ]);

  const handleReplaceDark = () => {
    darkChartInputRef.current?.click();
  };

  const handleReplaceLight = () => {
    lightChartInputRef.current?.click();
  };

const handleDarkChartUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!["image/jpeg", "image/png"].includes(file.type)) {
    alert("Only JPEG and PNG allowed");
    return;
  }

  const reader = new FileReader();
  reader.onload = () => {
    setImageSrc(reader.result);
    setCurrentType("dark");
    setCropModalOpen(true);
  };
  reader.readAsDataURL(file);

  e.target.value = "";
};

const handleLightChartUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!["image/jpeg", "image/png"].includes(file.type)) {
    alert("Only JPEG and PNG allowed");
    return;
  }

  const reader = new FileReader();
  reader.onload = () => {
    setImageSrc(reader.result);
    setCurrentType("light");
    setCropModalOpen(true);
  };
  reader.readAsDataURL(file);

  e.target.value = "";
};
const handleCropSave = async () => {
  try {
    setLoader(true);

    const croppedBlob = await getCroppedImg();
    const croppedFile = new File([croppedBlob], "cropped.jpg", {
      type: "image/jpeg",
    });

    const url = await uploadFile(croppedFile, setLoader);

    if (currentType === "dark") {
      setLocalDarkChart(url);
    } else {
      setLocalLightChart(url);
    }

    setCropModalOpen(false);
  } catch (err) {
    console.error(err);
  } finally {
    setLoader(false);
  }
};



  const handleRemoveDark = () => {
    setLocalDarkChart(null);
  };

  const handleRemoveLight = () => {
    setLocalLightChart(null);
  };

  // Save changes to parent state
  const handleSaveChanges = () => {
    setProjectSetup((prev) => ({
      ...prev,
      tokenomicsChartDark: {
        ...prev.tokenomicsChartDark,
        value: localDarkChart,
        error: false,
        errorMsg: "",
      },
      tokenomicsChartLight: {
        ...prev.tokenomicsChartLight,
        value: localLightChart,
        error: false,
        errorMsg: "",
      },
    }));

    handleClose();
  };

  // Cancel - discard changes and reset local state
  const handleCancel = () => {
    setLocalDarkChart(projectSetup.tokenomicsChartDark.value);
    setLocalLightChart(projectSetup.tokenomicsChartLight.value);
    handleClose();
  };

  return (
    <>
        <Modal
      className="publish-modall"
      show={show}
      onHide={handleCancel}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Change Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="publish_modal">
          <div className="tokicsimg">
            {/* Dark Theme Chart */}
            <div className="chart_left">
              <h4>Tokenomics Chart (Dark Theme)</h4>

              <div className="replace_Sides">
                {uploadingDark ? (
                  <div className="uploading-placeholder">
                    <p>Uploading...</p>
                  </div>
                ) : (
                  <>
                    {/* Show uploaded image */}
                    {localDarkChart ? (
                      <img
                        src={localDarkChart}
                        alt="Dark theme chart"
                        className="preview-img"
                      />
                    ) : (
                      /* Clickable upload box */
                      <div
                        className="charttinner"
                        onClick={() => darkChartInputRef.current.click()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_12_577)">
                            <path
                              d="M23.27 32.0008C23.046 32.0008 22.8167 31.9728 22.59 31.9128L1.9727 26.3915C0.559369 26.0022 -0.283297 24.5382 0.0873693 23.1248L2.6887 13.4288C2.7847 13.0728 3.15004 12.8662 3.5047 12.9568C3.8607 13.0515 4.07137 13.4182 3.9767 13.7728L1.3767 23.4662C1.19137 24.1728 1.61537 24.9088 2.32337 25.1048L22.9327 30.6235C23.6407 30.8102 24.3714 30.3888 24.5554 29.6848L25.5967 25.8262C25.6927 25.4702 26.058 25.2582 26.414 25.3555C26.77 25.4515 26.9794 25.8182 26.8847 26.1728L25.8447 30.0262C25.5314 31.2128 24.4514 32.0008 23.27 32.0008Z"
                              fill="black"
                            />
                            <path
                              d="M29.332 23.9993H7.9987C6.52803 23.9993 5.33203 22.8033 5.33203 21.3327V5.33268C5.33203 3.86202 6.52803 2.66602 7.9987 2.66602H29.332C30.8027 2.66602 31.9987 3.86202 31.9987 5.33268V21.3327C31.9987 22.8033 30.8027 23.9993 29.332 23.9993ZM7.9987 3.99935C7.26403 3.99935 6.66536 4.59802 6.66536 5.33268V21.3327C6.66536 22.0673 7.26403 22.666 7.9987 22.666H29.332C30.0667 22.666 30.6654 22.0673 30.6654 21.3327V5.33268C30.6654 4.59802 30.0667 3.99935 29.332 3.99935H7.9987Z"
                              fill="black"
                            />
                            <path
                              d="M11.9987 11.9993C10.528 11.9993 9.33203 10.8033 9.33203 9.33268C9.33203 7.86202 10.528 6.66602 11.9987 6.66602C13.4694 6.66602 14.6654 7.86202 14.6654 9.33268C14.6654 10.8033 13.4694 11.9993 11.9987 11.9993ZM11.9987 7.99935C11.264 7.99935 10.6654 8.59802 10.6654 9.33268C10.6654 10.0673 11.264 10.666 11.9987 10.666C12.7334 10.666 13.332 10.0673 13.332 9.33268C13.332 8.59802 12.7334 7.99935 11.9987 7.99935Z"
                              fill="black"
                            />
                            <path
                              d="M6.09278 22.5731C5.92211 22.5731 5.75145 22.5077 5.62078 22.3784C5.36078 22.1184 5.36078 21.6957 5.62078 21.4357L11.9181 15.1384C12.6728 14.3837 13.9914 14.3837 14.7461 15.1384L16.6208 17.0131L21.8101 10.7864C22.1874 10.3344 22.7421 10.0717 23.3328 10.0664H23.3474C23.9314 10.0664 24.4848 10.3197 24.8661 10.7637L31.8394 18.8997C32.0794 19.1784 32.0474 19.5997 31.7674 19.8397C31.4888 20.0797 31.0688 20.0491 30.8274 19.7677L23.8541 11.6317C23.7248 11.4824 23.5461 11.3997 23.3474 11.3997C23.2088 11.3877 22.9648 11.4837 22.8354 11.6397L17.1781 18.4277C17.0581 18.5717 16.8834 18.6584 16.6954 18.6664C16.5061 18.6797 16.3261 18.6051 16.1941 18.4717L13.8034 16.0811C13.5514 15.8304 13.1128 15.8304 12.8608 16.0811L6.56345 22.3784C6.43411 22.5077 6.26345 22.5731 6.09278 22.5731Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_12_577">
                              <rect width="32" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <h3>Tokenomics Chart (Dark Theme)</h3>
                        <h4>
                          1848x1050 resolution. Max 3 MB in JPEG or PNG format
                        </h4>
                      </div>
                    )}
                  </>
                )}

                {localDarkChart && !uploadingDark && (
                  <div className="buttons_modals">
                    <button className="replace" onClick={handleReplaceDark}>
                      Replace
                    </button>
                    <button className="remove" onClick={handleRemoveDark}>
                      Remove
                    </button>
                  </div>
                )}
              </div>

              <input
                type="file"
                ref={darkChartInputRef}
                accept="image/png, image/jpeg"
                onChange={handleDarkChartUpload}
                style={{ display: "none" }}
              />
              {projectSetup.tokenomicsChartDark.error && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "8px" }}>
                  {projectSetup.tokenomicsChartDark.errorMsg}
                </p>
              )}
            </div>

            {/* Light Theme Chart */}
            <div className="chart_left">
              <h4>Tokenomics Chart (Light Theme)</h4>

              <div className="replace_Sides">
                {uploadingLight ? (
                  <div className="uploading-placeholder">
                    <p>Uploading...</p>
                  </div>
                ) : (
                  <>
                    {/* Show uploaded image */}
                    {localLightChart ? (
                      <img
                        src={localLightChart}
                        alt="Light theme chart"
                        className="preview-img"
                      />
                    ) : (
                      /* Clickable charttinner only */
                      <div
                        className="charttinner"
                        onClick={() => lightChartInputRef.current.click()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_12_577)">
                            <path
                              d="M23.27 32.0008C23.046 32.0008 22.8167 31.9728 22.59 31.9128L1.9727 26.3915C0.559369 26.0022 -0.283297 24.5382 0.0873693 23.1248L2.6887 13.4288C2.7847 13.0728 3.15004 12.8662 3.5047 12.9568C3.8607 13.0515 4.07137 13.4182 3.9767 13.7728L1.3767 23.4662C1.19137 24.1728 1.61537 24.9088 2.32337 25.1048L22.9327 30.6235C23.6407 30.8102 24.3714 30.3888 24.5554 29.6848L25.5967 25.8262C25.6927 25.4702 26.058 25.2582 26.414 25.3555C26.77 25.4515 26.9794 25.8182 26.8847 26.1728L25.8447 30.0262C25.5314 31.2128 24.4514 32.0008 23.27 32.0008Z"
                              fill="black"
                            />
                            <path
                              d="M29.332 23.9993H7.9987C6.52803 23.9993 5.33203 22.8033 5.33203 21.3327V5.33268C5.33203 3.86202 6.52803 2.66602 7.9987 2.66602H29.332C30.8027 2.66602 31.9987 3.86202 31.9987 5.33268V21.3327C31.9987 22.8033 30.8027 23.9993 29.332 23.9993ZM7.9987 3.99935C7.26403 3.99935 6.66536 4.59802 6.66536 5.33268V21.3327C6.66536 22.0673 7.26403 22.666 7.9987 22.666H29.332C30.0667 22.666 30.6654 22.0673 30.6654 21.3327V5.33268C30.6654 4.59802 30.0667 3.99935 29.332 3.99935H7.9987Z"
                              fill="black"
                            />
                            <path
                              d="M11.9987 11.9993C10.528 11.9993 9.33203 10.8033 9.33203 9.33268C9.33203 7.86202 10.528 6.66602 11.9987 6.66602C13.4694 6.66602 14.6654 7.86202 14.6654 9.33268C14.6654 10.8033 13.4694 11.9993 11.9987 11.9993ZM11.9987 7.99935C11.264 7.99935 10.6654 8.59802 10.6654 9.33268C10.6654 10.0673 11.264 10.666 11.9987 10.666C12.7334 10.666 13.332 10.0673 13.332 9.33268C13.332 8.59802 12.7334 7.99935 11.9987 7.99935Z"
                              fill="black"
                            />
                            <path
                              d="M6.09278 22.5731C5.92211 22.5731 5.75145 22.5077 5.62078 22.3784C5.36078 22.1184 5.36078 21.6957 5.62078 21.4357L11.9181 15.1384C12.6728 14.3837 13.9914 14.3837 14.7461 15.1384L16.6208 17.0131L21.8101 10.7864C22.1874 10.3344 22.7421 10.0717 23.3328 10.0664H23.3474C23.9314 10.0664 24.4848 10.3197 24.8661 10.7637L31.8394 18.8997C32.0794 19.1784 32.0474 19.5997 31.7674 19.8397C31.4888 20.0797 31.0688 20.0491 30.8274 19.7677L23.8541 11.6317C23.7248 11.4824 23.5461 11.3997 23.3474 11.3997C23.2088 11.3877 22.9648 11.4837 22.8354 11.6397L17.1781 18.4277C17.0581 18.5717 16.8834 18.6584 16.6954 18.6664C16.5061 18.6797 16.3261 18.6051 16.1941 18.4717L13.8034 16.0811C13.5514 15.8304 13.1128 15.8304 12.8608 16.0811L6.56345 22.3784C6.43411 22.5077 6.26345 22.5731 6.09278 22.5731Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_12_577">
                              <rect width="32" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                        <h3>Tokenomics Chart (Light Theme)</h3>
                        <h4>
                          1848x1050 resolution. Max 3 MB in JPEG or PNG format
                        </h4>
                      </div>
                    )}
                  </>
                )}

                {localLightChart && !uploadingLight && (
                  <div className="buttons_modals">
                    <button className="replace" onClick={handleReplaceLight}>
                      Replace
                    </button>
                    <button className="remove" onClick={handleRemoveLight}>
                      Remove
                    </button>
                  </div>
                )}
              </div>

              <input
                type="file"
                ref={lightChartInputRef}
                accept="image/png, image/jpeg"
                onChange={handleLightChartUpload}
                style={{ display: "none" }}
              />
              {projectSetup.tokenomicsChartLight.error && (
                <p style={{ color: "red", fontSize: "12px", marginTop: "8px" }}>
                  {projectSetup.tokenomicsChartLight.errorMsg}
                </p>
              )}
            </div>
          </div>

          <p className="psmall">
            1848x1050 resolution. Max 3 MB in JPEG or PNG format
          </p>
          <p className="psmallnew">
            Images in 2880x660 resolution. Max 15 MB in JPEG or PNG format
          </p>

          <div className="publish_buttons">
            <button onClick={handleCancel} className="cancel_button">
              Cancel
            </button>
            <button
              className="confirm_button"
              onClick={handleSaveChanges}
              disabled={uploadingDark || uploadingLight}
            >
              Save Changes
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  <Modal
  className="publish-modall"
  show={cropModalOpen}
  onHide={() => setCropModalOpen(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Crop Image</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="publish_modal">
      <div className="croopppy">
        <div className="cropmodal">
          {imageSrc && (
            <div
              className="crop-container inercrop"
              style={{
                position: "relative",
                width: "100%",
                height: "240px",
                background: "#E7EEF2",
                borderRadius: "4px",
                overflow: "hidden",
              }}
            >
              <Cropper
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={1848 / 1050}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
          )}
        </div>

        <p>Drag to reposition image</p>

        <div className="zoom-slider">
          <h5>Zoom</h5>
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            style={{
              width: "100%",
              height: "8px",
              borderRadius: "10px",
              appearance: "none",
            }}
          />
        </div>

        <div className="publish_buttons">
          <button
            className="cancel_button"
            onClick={() => setCropModalOpen(false)}
          >
            Cancel
          </button>

          <button
            className="confirm_button"
            onClick={handleCropSave}
          >
            Crop & Upload
          </button>
        </div>
      </div>
    </div>
  </Modal.Body>
</Modal>


    </>

  );
};

export default TokenomicsChartModal;
